"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDateTimeString = exports.parseTimeString = exports.getTimeLabel = exports.createDateAtTime = exports.addHours = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _padStart = _interopRequireDefault(require("lodash/padStart"));

/**
 * This module contains utilities that work with time strings in the format
 * "HH:mm"
 */

/**
 * Convert a date object into a date + time string (e.g. "2018-12-31 03:20").
 */
var toDateTimeString = function toDateTimeString(dateObject) {
  return "".concat((0, _padStart["default"])(dateObject.getFullYear(), 4, "0"), "-").concat((0, _padStart["default"])(dateObject.getMonth() + 1, 2, "0"), "-").concat((0, _padStart["default"])(dateObject.getDate(), 2, "0"), " ").concat((0, _padStart["default"])(dateObject.getHours(), 2, "0"), ":").concat((0, _padStart["default"])(dateObject.getMinutes(), 2, "0"));
};
/**
 * Returns hour, minutes, and seconds as numbers time string
 * parseTimeString("02:30") -> { hour: 2, minute: 30, seconds: 0 }
 * parseTimeString("02:30:55") -> { hour: 2, minute: 30, seconds: 55 }
 */


exports.toDateTimeString = toDateTimeString;

var parseTimeString = function parseTimeString(timeString) {
  var _$exec = /([\d]+):([\d]+):?([\d]+)?/.exec(timeString),
      _$exec2 = (0, _slicedToArray2["default"])(_$exec, 4),
      hourString = _$exec2[1],
      minutesString = _$exec2[2],
      _$exec2$ = _$exec2[3],
      secondsString = _$exec2$ === void 0 ? "00" : _$exec2$; // We use Number over parseInt here because parseInt will assume
  // an 🤖 octal number if there's a leading zero (which will be the
  // case for time strings like "02:00")
  // https://stackoverflow.com/a/4090577


  return {
    hour: Number(hourString),
    minutes: Number(minutesString),
    seconds: Number(secondsString)
  };
};
/*
 * Create a date object at a specific time
 */


exports.parseTimeString = parseTimeString;

var createDateAtTime = function createDateAtTime(timeString) {
  var _parseTimeString = parseTimeString(timeString),
      hour = _parseTimeString.hour,
      minutes = _parseTimeString.minutes,
      seconds = _parseTimeString.seconds;

  var date = new Date();
  date.setHours(hour);
  date.setMinutes(minutes);
  date.setSeconds(seconds);
  return date;
};
/*
 * Adds hours to a time string by an increment. Returns time string
 * addHours("12:33", -3) // returns "09:33"
 */


exports.createDateAtTime = createDateAtTime;

var addHours = function addHours(timeString, increment) {
  var _parseTimeString2 = parseTimeString(timeString),
      hour = _parseTimeString2.hour,
      minutes = _parseTimeString2.minutes;

  return "".concat((0, _padStart["default"])(hour + increment, 2, "0"), ":").concat((0, _padStart["default"])(minutes, 2, "0"));
};
/**
 * Returns localized time label from a time string.
 * getTimeLabel({ time: "14:00", locale: "zh-CN" }) // returns 下午02:00
 */


exports.addHours = addHours;

var getTimeLabel = function getTimeLabel(_ref) {
  var time = _ref.time,
      locale = _ref.locale,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? {
    hour: "2-digit",
    minute: "2-digit"
  } : _ref$format;
  return createDateAtTime(time).toLocaleTimeString(locale, format);
};

exports.getTimeLabel = getTimeLabel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/_utils/time-string.js
// module id = 882
// module chunks = 0